import React, { useEffect, useState, useRef } from 'react';

import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate } from "react-router-dom";

function StaffDetails() {
    const [loading, setLoading] = useState(true);
    const [staffCode, setStaffCode] = useState([]);
    const [error, setError] = useState(null);
    const formRef = useRef(null);

         const [currentPage, setCurrentPage] = useState(1);
         const [rowsPerPage] = useState(100);

         const [searchQuery, setSearchQuery] = useState("");
         const [formData, setFormData] = useState({ area_code: "", network: "", date: "", toDate: "" })
         const initialFormData = { area_code: "", network: "", date: "", toDate: "" }
         const navigate = useNavigate();
    const user = getCookie('user');
    
    if (!user) { navigate('/'); }

    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) return value;
        }
        return null;
    }

    const ViewClick = (area_code) => {
        navigate(`/staffReportView/${area_code}`, { user });
    };

    const [isEditMode, setIsEditMode] = useState(false);
    const [editId, setEditId] = useState(null);

    const [addStaff, setAddStaff] = useState({
        collectionstaff: "",
        date: "",
        mobilenumber: "",
        address: "",
        password: "",
        areacode: "",
        role: "",
    });

  
    // Handle Input Change
    const handleInputChange = (e) => {
        setAddStaff({ ...addStaff, [e.target.name]: e.target.value });
    };

    // Handle Edit Click
    const handleEditClick = (staff) => {
        setIsEditMode(true);
        setEditId(staff.id);

        setAddStaff({
            collectionstaff: staff.staff_name ?? "",
            date: staff.dob ?? "",
            mobilenumber: staff.mobile ?? "",
            address: staff.address ?? "",
            password: staff.password ?? "",
            areacode: staff.area_code ?? "",
            role: staff.desn ?? "",
        });
          // Scroll to the form
    if (formRef.current) {
        formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
    
        console.log("📤 Submitting Data:", { ...addStaff, user });
    
        if (!user) {
            toast.error("User session expired. Please log in again.");
            return;
        }
    
        try {
            let response;
            if (isEditMode) {
                response = await axios.post("https://node.cabletvpay.in/EditStaff", { id: editId, ...addStaff, user });
            } else {
                response = await axios.post("https://node.cabletvpay.in/AddStaffSpecific", { ...addStaff, user });
            }
    
            console.log("✅ Server Response:", response.data);
            toast.success(isEditMode ? "Staff updated successfully" : "Staff added successfully");
    
            // Reset form & fetch updated data
            setAddStaff({ collectionstaff: "", date: "", mobilenumber: "", address: "", password: "", areacode: "", role: "" });
            setIsEditMode(false);
            setEditId(null);
            fetchUserData();
        } catch (error) {
            console.error("❌ Error saving data:", error.response?.data || error);
            toast.error(error.response?.data?.message || "Failed to save staff details.");
        }
    };
    
   // Fetch Staff Data
   const fetchUserData = async () => {
    try {
        const response = await axios.post('https://node.cabletvpay.in/staffGetInfo', { user });
        if (response.status === 200) {
            setStaffCode(response.data.staffCode);
        }
    } catch (err) {
        setError(err.response?.data?.message || "Error fetching data");
    } finally {
        setLoading(false);
    }
};
    // Handle Delete
    const handleDelete = async (id) => {
        try {
            const response = await axios.post(`https://node.cabletvpay.in/deleteStaff`, { user, id });
            if (response.status === 200) {
                toast.success("Staff deleted successfully.");
                fetchUserData();
            }
        } catch (err) {
            toast.error(err.response?.data?.message || "Error deleting staff");
        }
    };

    useEffect(() => {
        fetchUserData();
    }, []);
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = staffCode.slice(indexOfFirstRow, indexOfLastRow);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const totalPages = Math.ceil(staffCode.length / rowsPerPage);
    const filteredRows = currentRows.filter((row) => Object.values(row).some(value => String(value).toLowerCase().includes(searchQuery.toLowerCase())));
    const handleClear = () => { setFormData(initialFormData); };
    const downloadCSV = () => {
        const headers = ["Sno", "Customer__Name", "Acc_no", "Code", "STB_no", "D_no", "Flat_name", "Street__name", "Phone", "Pay Status", "Plan Amount", "Paid Amount", "Paid_Date", "Balance Amount", "Discount Amount", "Advance Amount", "Pending Amount", "Staff__Code", "Network", "Paid_time", "Package", "Added_date", "Collection Staff"];
        const csvRows = [];
        csvRows.push(headers.join(","));
        staffCode.forEach(row => { csvRows.push([row.id, row.name, row.account_num, row.acc_num, row.serial_num, row.doorno, row.flat_name, row.street, row.mobile, row.status, row.pay_amt, row.paid_amt, row.paid_date, row.balance, row.discount, row.extra_Balance_amt, row.pend_amt, row.area_code, row.net_name, row.paid_time, row.package, row.adate, row.col_boy].join(",")); });
        const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "CableTvPay.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };
    if (loading) return (
        <div className="content-wrapper d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
            <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="0.75" />
        </div>
    );

    if (error) return <div className='d-flex justify-content-center align-items-center min-vh-100'>Error: {error}</div>;

    return (
        <div className="content-wrapper">
            <div className="content-header pt-1">
                <div className="my-3">
                    <div className="fs-4 valuesDec h4">COLLECTION STAFF DETAILS</div>
                    <div style={{ position: 'absolute', top: '30px' }}><ToastContainer theme='dark' /></div>
                </div>
                <hr />
                <div className="mt-3 mb-2 mb-lg-5 mx-lg-5">
                    <div className="border-0 px-1">
                    <form  ref={formRef}  onSubmit={handleFormSubmit}>
                <div className="row mx-3 d-flex justify-content-center">
                    {/* Collection Staff Name */}
                    <div className="col-lg-3 col-md-6 col-12 mb-2">
                        <div className="form-group">
                            <label htmlFor="collectionstaff">Collection Staff Name</label>
                            <input type="text" className="form-control text-light bg-gradient-navy border-0 text-white elevation-3" name="collectionstaff"
                                value={addStaff.collectionstaff} onChange={handleInputChange}
                                placeholder="Collection Staff Name..." required />
                        </div>
                    </div>

                    {/* Date of Birth */}
                    <div className="col-lg-3 col-md-6 col-12 mb-2">
                        <div className="form-group">
                            <label htmlFor="date">Date Of Birth</label>
                            <input type="date" className="form-control text-light bg-gradient-navy border-0 text-white elevation-3" name="date"
                                value={addStaff.date} onChange={handleInputChange} required />
                        </div>
                    </div>

                    {/* Mobile Number */}
                    <div className="col-lg-3 col-md-6 col-12 mb-2">
                        <div className="form-group">
                            <label htmlFor="mobilenumber">Mobile Number</label>
                            <input type="text" className="form-control text-light bg-gradient-navy border-0 text-white elevation-3" name="mobilenumber"
                                value={addStaff.mobilenumber} onChange={handleInputChange}
                                placeholder="Mobile Number..." required />
                        </div>
                    </div>

                    {/* Address */}
                    <div className="col-lg-3 col-md-6 col-12 mb-2">
                        <div className="form-group">
                            <label htmlFor="address">Address</label>
                            <input type="text" className="form-control text-light bg-gradient-navy border-0 text-white elevation-3" name="address"
                                value={addStaff.address} onChange={handleInputChange}
                                placeholder="Address..." required />
                        </div>
                    </div>

                    {/* Password */}
                    <div className="col-lg-3 col-md-6 col-12 mb-2">
                        <div className="form-group">
                            <label htmlFor="password">Password</label>
                            <input type="text" className="form-control text-light bg-gradient-navy border-0 text-white elevation-3" name="password"
                                value={addStaff.password} onChange={handleInputChange}
                                placeholder="Password..." required />
                        </div>
                    </div>

                    {/* Staff Code */}
                    <div className="col-lg-3 col-md-6 col-12 mb-2">
                        <div className="form-group">
                            <label htmlFor="areacode">Staff Code</label>
                            <input type="text" className="form-control text-light bg-gradient-navy border-0 text-white elevation-3" name="areacode"
                                value={addStaff.areacode} onChange={handleInputChange}
                                placeholder="Staff Code..." required />
                        </div>
                    </div>

                    {/* Role */}
                    <div className="col-lg-3 col-md-6 col-12 mb-2">
                        <div className="form-group">
                            <label htmlFor="role">Role</label>
                            <select className="form-control text-light bg-gradient-navy border-0 text-white elevation-3" name="role"
                                value={addStaff.role} onChange={handleInputChange} required>
                                <option value="">Select Role</option>
                                <option value="super admin">Super Admin</option>
                                <option value="admin">Admin</option>
                                <option value="employee">Employee</option>
                            </select>
                        </div>
                    </div>

                    {/* Submit Button */}
                    <div className="col-lg-3 col-md-6 col-12 mb-2 d-flex justify-content-center pt-lg-4 pb-lg-3 mt-lg-2 pt-2">
                        <input type="submit" className="btn border-0  bg-info filterBtn text-light pb-3 pb-lg-1 w-100"
                            value={isEditMode ? "Update Staff" : "Add Staff"} />
                    </div>
                </div>
            </form>
                    </div>
                </div>


                <div className="card elevation-5 mt-3 mt-lg-5" style={{ backgroundColor: "#cccccc" }}>
                    <div className="card-header filterBtn">
                        <div className="row">
                            {/* Header Title */}
                            <div className="col-lg-4">
                                <div className="text-left mb-lg-0 w-50">
                                    <h4 className="pb-0 mb-0 mt-1 text-navy">Filter Details</h4>
                                </div>
                            </div>
                            {/* Actions */}
                            <div className="col-lg-8 mt-1">
                                <span>
                                    <div className="row w-auto">
                                        {/* Search Bar */}
                                        <div className="col-11 col-lg-6">
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control text-navy bg-light border-0 px-1 py-0"
                                                    placeholder="Search..."
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                    style={{ borderRadius: "5px 0 0 5px" }}
                                                />
                                                <span
                                                    className="input-group-text bg-light text-navy border-0 px-2"
                                                    id="basic-addon1"
                                                    style={{ borderRadius: "0 5px 5px 0" }}
                                                >
                                                    <i className="fas fa-search" />
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1 mt-lg-0">
                                            <div className="d-flex justify-content-end">
                                                <div className=" btn-group">
                                                    <button
                                                        onClick={downloadCSV}
                                                        className="btn btn-dark border-right px-lg-3 px-5"
                                                    >
                                                        <i className="fas fa-download" /> Download
                                                    </button>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>


                    <div className="card-body p-0">
                        <table id="myTable" className="table table-bordered table-responsive-lg">
                            <thead className="bg-gradient-navy">
                                <tr>
                                    <th>Sl_No     </th>
                                    <th>Name</th>
                                    <th>User ID/Mobile Number</th>
                                    <th>Password</th>
                                    <th>Staff Code</th>
                                    <th>Job Role</th>
                                    <th>Date Of Birth</th>
                                    <th>Address</th>
                                    <th>Current Location</th>
                                    <th>Collection Details</th>
                                    <th>Collection Amount</th>
                                    <th>Edit</th>
                                    <th>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {staffCode.length > 0 ? (
                                    staffCode.map((row, index) => (
                                        <tr key={index} style={{ backgroundColor: row.Pay === "unpaid" ? "#ffd9de" : "#cffcd0" }}>
                                            <td>{index+1}</td>
                                            <td>{row.staff_name}</td>
                                            <td>{row.mobile}</td>
                                            <td>{row.password}</td>
                                            <td>{row.area_code}</td>
                                            <td>{row.desn}</td>
                                            <td>{row.dob}</td>
                                            <td>{row.address}</td>
                                            <td>
                                                <div className="d-flex justify-content-center">
                                                    <button className="btn btn-info">Location</button>
                                                </div>
                                            </td>
                                            <td onClick={() => ViewClick(row.area_code)}><div className="d-flex justify-content-center">

<button className="btn btn-info"> View</button>

</div></td>
                                            <td>{row.total_amount}</td>
                                            <td onClick={() => handleEditClick(row)}>
                                <button className="btn text-fuchsia"><i className="fas fa-edit"></i></button>
                            </td>
                                            <td className='text-center'><button className='btn btn-danger' onClick={() => handleDelete(row.id)}><i className="fas fa-trash" /></button></td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="30">No results found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
               
            </div>
        </div>
    );
}

export default StaffDetails;
